// import React from 'react'

// const CardOperdonView = ({service}) => {
//   return (
//     <>
//         <h4>{service.car_title}</h4>
//         <hr/>
//         <h5>سرویس</h5>:<h6>{service.ok_title}</h6>
//         <h5>تاریخ سرویس:</h5>
//         <h6>{service.operDonDateP}</h6>
//     </>    
//   )
// }

// export default CardOperdonView

//////////////////////////////////////////////////////////////////
import React from 'react'
import { FaRegCalendarAlt } from 'react-icons/fa';
import { SiSpeedtest } from 'react-icons/si';
import ServiceIcon from '../../operate/card-two-side/service-icon';
const CardOperdonView = ({ service }) => {

  // return (
  //   <div className="card shadow-sm h-100">
  //     <div className="card-header bg-Light py-2 px-3">
  //       <div className="d-flex justify-content-between align-items-center">
  //         <div className="d-flex align-items-center">
  //           <ServiceIcon categoryId={service.ok_id} size={20} className="me-2"/>
  //           <div>
  //             <span className="fw-bold d-block small">{service.opTitle}</span>
  //             <small className="text-muted">{service.car_title}</small>
  //           </div>
  //         </div>
  //         <div className="text-primary">
  //           {service.ok_serviceType === "km" 
  //             ? <SiSpeedtest size={18}/> 
  //             : <FaRegCalendarAlt size={18}/>}
  //         </div>
  //       </div>
  //     </div>

  //     <div className="card-body">
  //       <p className="mb-2">
  //         <strong>کیلومتر انجام سرویس:</strong> {service.operDonKM}
  //       </p>
  //       <p className="mb-2">
  //         <strong>تاریخ انجام سرویس:</strong> {service.operDonDateP}
  //       </p>
  //       <p className="mb-2">
  //         <strong>هزینه انجام سرویس:</strong> {service.cost}
  //       </p>
  //       <p className="mb-2">
  //         <strong>توضیحات:</strong> {service.description}
  //       </p>
  //     </div>
  //   </div>
  // );

  return (
    <div className="card shadow-sm h-100">
      <div className="card-header bg-light py-2 px-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <ServiceIcon categoryId={service.ok_id} size={20} className="me-2" />
            <div>
              <span className="fw-bold d-block small">{service.opTitle}</span>
              <small className="text-muted">{service.car_title}</small>
            </div>
          </div>
          <div className="text-primary">
            {service.ok_serviceType === "km"
              ? <SiSpeedtest size={18} />
              : <FaRegCalendarAlt size={18} />}
          </div>
        </div>
      </div>
  
      <div className="card-body">
        <div className="row gy-2">
          <div className="col-12 col-md-6">
            <div className="d-flex align-items-center gap-2">
              <strong className="text-muted mb-0">کیلومتر انجام سرویس:</strong>
              <span>{service.operDonKM}</span>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="d-flex align-items-center gap-2">
              <strong className="text-muted mb-0">تاریخ انجام سرویس:</strong>
              <span>{service.operDonDateP}</span>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="d-flex align-items-center gap-2">
              <strong className="text-muted mb-0">هزینه انجام سرویس:</strong>
              <span>{service.cost}</span>
            </div>
          </div>
          <div className="col-12">
            <div className="d-flex flex-column">
              <strong className="text-muted mb-1">توضیحات:</strong>
              <span className="text-truncate-2">{service.description}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  ); 
};

export default CardOperdonView